import React, { useState } from 'react';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = (e) => {
    e?.preventDefault();
    setSubscribed(true);
    setEmail('');
    setTimeout(() => setSubscribed(false), 3000);
  };

  return (
    <section id="newsletter" className="py-20 bg-gradient-to-br from-[#96121D] via-gray-900 to-[#9B8E57] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2240%22%20height%3D%2240%22%20viewBox%3D%220%200%2040%2040%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20fill%3D%22%23ffffff%22%20fill-opacity%3D%220.1%22%3E%3Cpath%20d%3D%22M20%2020.5V18H0v-2h20v2.5zm-.5%200h-2v-2H20v2zm-.5%200h-2v-2H20v2z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E')]"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Newsletter Icon */}
        <div className="w-20 h-20 bg-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-8 border border-[#9B8E57]/30">
          <svg className="w-10 h-10 text-[#9B8E57]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
          </svg>
        </div>

        {/* Header */}
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Restez Informé des Dernières 
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#9B8E57] to-amber-400"> Innovations</span>
        </h2>

        <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed">
          Recevez chaque semaine nos insights exclusifs sur l'Intelligence Artificielle, 
          les tendances du secteur et les opportunités de développement professionnel.
        </p>

        {/* Benefits */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="flex items-center justify-center space-x-3 text-white/90 bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
            <div className="w-10 h-10 bg-[#9B8E57]/30 rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#9B8E57]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
              </svg>
            </div>
            <span className="text-sm font-semibold">Insights IA Exclusifs</span>
          </div>
          <div className="flex items-center justify-center space-x-3 text-white/90 bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
            <div className="w-10 h-10 bg-[#96121D]/30 rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#96121D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
              </svg>
            </div>
            <span className="text-sm font-semibold">Guides Pratiques</span>
          </div>
          <div className="flex items-center justify-center space-x-3 text-white/90 bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
            <div className="w-10 h-10 bg-amber-600/30 rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <span className="text-sm font-semibold">Accès Prioritaire</span>
          </div>
        </div>

        {/* Subscription Form */}
        {!subscribed ? (
          <form onSubmit={handleSubmit} className="max-w-md mx-auto">
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex-1">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e?.target?.value)}
                  placeholder="Votre adresse email"
                  required
                  className="w-full px-5 py-4 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-[#9B8E57] focus:border-transparent"
                />
              </div>
              <button
                type="submit"
                className="px-8 py-4 bg-gradient-to-r from-[#9B8E57] to-amber-600 text-white font-bold rounded-xl hover:from-[#9B8E57]/90 hover:to-amber-600/90 transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap"
              >
                S'abonner
              </button>
            </div>
            <p className="text-white/70 text-sm mt-4">
              Gratuit • Désabonnement facile • Pas de spam
            </p>
          </form>
        ) : (
          <div className="max-w-md mx-auto">
            <div className="bg-green-600/20 backdrop-blur-sm border border-green-400/30 rounded-xl p-6">
              <div className="flex items-center justify-center space-x-3 mb-3">
                <div className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                  </svg>
                </div>
                <span className="text-green-200 font-bold text-lg">Inscription Réussie!</span>
              </div>
              <p className="text-green-100 text-sm">
                Merci pour votre inscription. Vous recevrez notre prochain newsletter dans votre boîte mail.
              </p>
            </div>
          </div>
        )}

        {/* Social Proof */}
        <div className="mt-12">
          <p className="text-white/80 text-sm mb-4 font-medium">Rejoint par plus de 2,500+ professionnels</p>
          <div className="flex justify-center items-center space-x-2">
            {[...Array(5)]?.map((_, i) => (
              <div key={i} className="w-12 h-12 bg-gradient-to-br from-[#96121D] to-[#9B8E57] rounded-full flex items-center justify-center border-2 border-white/20">
                <span className="text-white text-sm font-bold">{String.fromCharCode(65 + i)}</span>
              </div>
            ))}
            <div className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center border-2 border-dashed border-white/30">
              <span className="text-white text-lg font-bold">+</span>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-10 left-10 w-24 h-24 bg-[#9B8E57]/20 rounded-full blur-2xl"></div>
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-[#96121D]/20 rounded-full blur-2xl"></div>
    </section>
  );
};

export default Newsletter;